async function createSubdoc(repo, type, init) {
    const handle = await repo.create2();
    handle.change((doc) => {
        doc["@patchwork"] = { type };
        init(doc);
    });
    return handle;
}
export const createDefaultAccount = async (accountHandle, repo) => {
    const [rootFolder, moduleSettings, contact] = await Promise.all([
        createSubdoc(repo, "folder", (doc) => {
            doc.title = "New Folder";
            doc.docs = [];
        }),
        createSubdoc(repo, "patchwork:module-settings", (doc) => {
            doc.modules = [];
        }),
        createSubdoc(repo, "contact", (doc) => {
            doc.type = "anonymous";
        }),
    ]);
    accountHandle.change((doc) => {
        doc.rootFolderUrl = rootFolder.url;
        doc.moduleSettingsUrl = moduleSettings.url;
        doc.contactUrl = contact.url;
    });
};
